import { Slider } from '../../components/Slider';
import { useEditorStore } from '../../store/editorStore';

// Sharpening, noise reduction, texture, clarity, dehaze.
export function DetailPanel() {
  const state = useEditorStore((s) => s.state);
  const set = useEditorStore((s) => s.set);

  return (
    <>
      <p className="hint">Sharpening</p>
      <Slider
        label="Amount"
        help="sharpening"
        value={state.sharpenAmount}
        min={0}
        max={150}
        onChange={(v) => set('sharpenAmount', v)}
      />
      <Slider
        label="Radius"
        value={state.sharpenRadius}
        min={0.5}
        max={3}
        step={0.1}
        defaultValue={1}
        onChange={(v) => set('sharpenRadius', v)}
      />

      <p className="hint">Noise Reduction</p>
      <Slider
        label="Luminance"
        help="noiseReduction"
        value={state.noiseReduction}
        min={0}
        max={100}
        onChange={(v) => set('noiseReduction', v)}
      />
      <Slider
        label="Color"
        value={state.colorNoiseReduction}
        min={0}
        max={100}
        onChange={(v) => set('colorNoiseReduction', v)}
      />

      <p className="hint">Presence</p>
      <Slider
        label="Texture"
        help="texture"
        value={state.texture}
        min={-100}
        max={100}
        onChange={(v) => set('texture', v)}
      />
      <Slider
        label="Clarity"
        help="clarity"
        value={state.clarity}
        min={-100}
        max={100}
        onChange={(v) => set('clarity', v)}
      />
      <Slider
        label="Dehaze"
        help="dehaze"
        value={state.dehaze}
        min={-100}
        max={100}
        onChange={(v) => set('dehaze', v)}
      />
    </>
  );
}
